import { useTranslation } from "react-i18next";
import { useUserStore } from "@/store/userStore";
import { useBookingsSupabaseStore } from "@/store/api/bookingsSupabaseStore";
import { useUserProfile } from "@/hooks/useUserProfile";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";
import { AthleteHeroBackground } from "@/components/athlete/AthleteHeroBackground";

export function HeroSection() {
  const { t } = useTranslation(["athlete"]);
  const { user } = useUserStore();
  const { bookings } = useBookingsSupabaseStore();
  const { profile } = useUserProfile();
  const { logoDark, brandName, athleteBackgrounds, athleteTheme } = useThemeCustomization();
  const backgroundUrl = athleteBackgrounds.dashboard;
  const showLogo = athleteTheme.variant !== "dark-premium";

  const now = new Date();
  const hours = now.getHours();

  let greetingKey = "dashboard.greeting.morning";
  if (hours >= 12 && hours < 18) {
    greetingKey = "dashboard.greeting.afternoon";
  } else if (hours >= 18) {
    greetingKey = "dashboard.greeting.evening";
  }

  const today = now.toISOString().split('T')[0];
  // `user` est typé `User | null` et `clearAuth()` le passe à `null` alors que
  // le composant est encore monté : `user.id` levait en plein rendu.
  const userId = user?.id;
  const hasBookingToday = bookings.some(b =>
    b.date === today && b.status === 'upcoming' && b.userId === userId
  );

  const firstName = profile?.first_name || user?.email?.split('@')[0] || "Champion";

  return (
    <div className="athlete-hero relative overflow-hidden min-h-[132px] md:min-h-[182px]">
      {/* Background image */}
      <AthleteHeroBackground src={backgroundUrl} className="absolute inset-0 w-full h-full object-cover" />

      {/* Dark overlay gradient */}
      <div className="athlete-hero-overlay absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 p-4 md:p-6 flex flex-col justify-end h-full min-h-[132px] md:min-h-[182px]">
        {showLogo && (
          <img src={logoDark} alt={brandName} className="athlete-brand-logo absolute left-5 top-5 md:left-8 md:top-8" />
        )}

        <p className="text-sm text-foreground/90">{t(greetingKey)}</p>
        <h1 className="text-[26px] leading-none md:text-4xl font-extrabold text-foreground">
          {firstName}
        </h1>
        <div className="mt-1.5 h-0.5 w-10 bg-primary" aria-hidden="true" />

        {!hasBookingToday && (
          <p className="mt-1.5 max-w-md text-xs text-foreground/90">
            {t('dashboard.noUpcoming', { defaultValue: "Tu n'as pas encore réservé aujourd'hui !" })}
          </p>
        )}

      </div>
    </div>
  );
}
